// /assets/caixinha.js

// Se você já tiver setLoading num outro arquivo, pode omitir esta parte
function setLoading(button, isLoading) {
  const spinner = button.querySelector('.loading-spinner');
  if (isLoading) {
    button.disabled = true;
    spinner.style.display = 'inline-block';
    button.classList.add('loading');
  } else {
    button.disabled = false;
    spinner.style.display = 'none';
    button.classList.remove('loading');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const btn = document.getElementById('add-caixinha-btn');
  if (!btn) return;

  btn.addEventListener('click', () => {
    setLoading(btn, true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: 46821973131481,
        quantity: 1
      })
    })
    .then(response => {
      if (!response.ok) throw new Error('Falha ao adicionar a caixinha no carrinho.');
      return response.json();
    })
    .then(() => {
      // recarrega o carro ou atualiza a mini-cart
      location.reload();
    })
    .catch(err => {
      console.error(err);
      alert(err.message);
    })
    .finally(() => {
      setLoading(btn, false);
    });
  });
});
